import { useAuth0 } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";
import type React from "react";
import { useEffect } from "react";

// Component to set Sentry user context
export function SentryUserProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	const { user, isAuthenticated, isLoading } = useAuth0();

	useEffect(() => {
		// Wait for Auth0 to finish loading
		if (isLoading) return;

		if (isAuthenticated && user) {
			const sentryUser = {
				id: user.sub,
				email: user.email,
				username: user.name,
				ip_address: "{{auto}}", // Let Sentry auto-detect IP
			};
			Sentry.setUser(sentryUser);
		} else {
			// Clear user context when not authenticated
			Sentry.setUser(null);
		}
	}, [isAuthenticated, user, isLoading]);

	return <>{children}</>;
}
